/**
 * The ONLY sanctioned credit-rounding site (treasury-doctrine: credits
 * are exact decimal strings everywhere except UI render time).
 *
 * Semantics extracted verbatim from CreditBalancePill: non-finite input
 * passes through unformatted; finite values render with exactly 2
 * fraction digits and grouping ("1,234.50").
 */

const formatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatCredits({
  credits,
}: {
  credits: number | string;
}): string {
  const num = Number(credits);
  if (!Number.isFinite(num)) return String(credits);
  return formatter.format(num);
}
